import { AlertColor as MuiColor } from '@mui/material/Alert';
import { useState } from 'react';

export interface SnackbarState {
  open: boolean;
  message: string;
  severity: MuiColor | undefined;
  duration: number | null;
}

const useSnackbar = () => {
  const [snackbarState, setSnackbarState] = useState<SnackbarState>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  const handleCloseSnackBar = () => {
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  return {
    snackbarState,
    openSnackbar: handleOpenSnackBar,
    handleCloseSnackBar: handleCloseSnackBar,
  };
};

export default useSnackbar;
